import React from 'react';
import { useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import {
  SalesRecording, TripMatch, TripMatchStatus, TripRequest,
} from '@marageti/z4-sdk/lib/travel';
import { enqueueSnackbar } from 'notistack';
import SalesView from './sales-view';
import { AlertPage, createAlertObj } from '../../../components/alerts/utils';
import { useAuthStore } from '../../../store';

const SalesContainer = () => {
  const apiClient = useApiClient();
  const { tripMatchId } = useParams();
  const { loggedInAgent } = useAuthStore();

  const { data: tripMatch, isLoading: isLoadingTM, mutate } = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
  const { data: salesRecordings, isLoading: isLoadingSR } = useFetch<SalesRecording[]>(
    apiClient.tripMatchesClient.getTripMatchSalesRecordings,
    [tripMatchId],
    !!tripMatchId,
    { revalidateOnMount: true },
  );
  const { data: tripRequest } = useFetch<TripRequest>(
    apiClient.tripRequestsClient.getTripRequest,
    [tripMatch?.tripRequestId],
    !!tripMatch?.tripRequestId,
  );

  const handleReactivation = async () => {
    if (tripMatchId && tripMatch) {
      try {
        await apiClient.tripMatchesClient.putTripMatchStatus(tripMatchId, {
          id: tripMatchId,
          status: TripMatchStatus.MatchActive,
          statusInfo: {
            reason: 'Agent Reactivated Trip',
          },
        });
        mutate();
        enqueueSnackbar('Trip reactivated.', { variant: 'success' });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const alert = createAlertObj(tripMatch, salesRecordings, loggedInAgent, handleReactivation, tripRequest?.status, AlertPage.Sales);

  return (
    <SalesView
      alert={alert}
      isLoading={isLoadingTM || isLoadingSR}
      sales={salesRecordings}
      tripMatchStatus={tripMatch?.status}
    />
  );
};

export default SalesContainer;
